
<template>
  <div class="content">
    <div @click="seekLamp" class="bgImg">
      <div class="list1"></div>
      <div class="text">寻灯</div>
    </div>
    <div @click="installLamp" class="bgImg">
      <div class="list2"></div>
      <div class="text">安灯作业</div>
    </div>
    <div @click="pilgrimsManage" class="bgImg">
      <div class="list3"></div>
      <div class="text">香客信息管理</div>
    </div>
    <div @click="deliverData" class="bgImg">
      <div class="list4"></div>
      <div class="text">传送资料</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  methods:{
    seekLamp(){
      this.$router.push('/seekLamp/list')
    },
    installLamp(){
      this.$router.push('/installLamp/list')
    },
    pilgrimsManage(){
      this.$router.push('/pilgrimsManage/list')
    },
    deliverData(){
      this.$router.push('/deliverData/list')
    },
  },
  mounted(){
    // window.speechSynthesis.speak(new SpeechSynthesisUtterance('111112222222'))
  }
};
</script>
<style lang="less" scoped>
  .content{
    width:1920px;
    height:1080px;
    background:rgba(250,252,252,1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
.bgImg{
  background: url("../assets/c_bg.png") center no-repeat;
  width: 400px;
  height: 240px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-right: 20px;
}
  .list1{
    background: url("../assets/c_ic_01.png") center no-repeat;
    width: 100px;
    height: 100px;
    margin-left: 60px;
    margin-right: 60px;
  }
  .list2{
    background: url("../assets/c_ic_02.png") center no-repeat;
    width: 100px;
    height: 100px;
    margin-left: 60px;
    margin-right: 33x;
  }
  .list3{
    background: url("../assets/c_ic_03.png") center no-repeat;
    width: 100px;
    height: 100px;
    margin-left: 60px;
  }
  .list4{
    background: url("../assets/c_ic_04.png") center no-repeat;
    width: 100px;
    height: 100px;
    margin-left: 60px;
    margin-right: 40px;
  }
  .text{
    font-size:30px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue